/* esm.sh - @radix-ui/react-use-effect-event@0.0.2 */
export * from "/*@radix-ui/react-use-effect-event@0.0.2/esnext/react-use-effect-event.mjs";
